// import { projectActions } from '../store/reducers/projectReducer';
import * as _ from 'lodash';
import moment from 'moment';
import * as str from 'underscore.string';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TranformtionImpactServerClientFilterObjectService {
    public static $inject = ['store', 'sessionService'];

    constructor() {

    }

    public getNewjsonData(inputJson, enums, envId, convertOprationName):any {
        let outputJson = Object.assign({}, inputJson);
        outputJson.noDataText = "No Drift Detected";
        outputJson.operationType = convertOprationName(inputJson.mainOperation);
        if (outputJson.operationType.toLowerCase().indexOf("build") != -1) {
            outputJson.noDataText = "No Changes Detected For The Build";
        }
        if (outputJson.mainOperation.indexOf("ENV_VALIDATE") != -1 ||
            outputJson.mainOperation.indexOf("ENV_SETVER") != -1 ||
            outputJson.mainOperation.indexOf("ENV_UPGRADE_SCR") != -1 ||
            outputJson.mainOperation.indexOf("ENV_ROLLBACK") != -1 ||
            outputJson.mainOperation.indexOf("ENV_DEPLOYMENT") != -1 ||
            outputJson.mainOperation.indexOf("ENV_UPGRADE_SCR") != -1) {
            outputJson.noDataText = "Configuration as expected";
        }
        outputJson.actionDefs = [];
        outputJson.scheculedOn = this.convertUTCtoLocal(outputJson.scheculedOn);
        if (outputJson.options) {
            //we convert all string to boolean
            outputJson.options.DisableConstraintsInContentScript = str.toBoolean(outputJson.options.DisableConstraintsInContentScript);//
            outputJson.options.IncludeSchemaNamePrefix = str.toBoolean(outputJson.options.IncludeSchemaNamePrefix);
            outputJson.options.IsSaveDataInOldStructure = str.toBoolean(outputJson.options.IsSaveDataInOldStructure);
            outputJson.options.SeparateScriptForEachTarget = str.toBoolean(outputJson.options.SeparateScriptForEachTarget);
            outputJson.options.IsTestEnvironment = str.toBoolean(outputJson.options.IsTestEnvironment);
            //we match the enums
            try {
                if (outputJson.options.DuplicationAction) outputJson.options.DuplicationActionDisplay = enums.DuplicationActionTypes[parseInt(outputJson.options.DuplicationAction)];
            } catch (e) {
                console.log(e);
            }
            try {
                if (outputJson.options.ConflictAction) outputJson.options.ConflictActionDisplay = enums.ConflictResloveActionTypes[parseInt(outputJson.options.ConflictAction)];
            } catch (e) {
                console.log(e);
            }
            try {
                if (outputJson.options.FileVersionControlType) outputJson.options.FileVersionControlTypeDisplay = enums.FileVersionControlTypes[parseInt(outputJson.options.FileVersionControlType)];
            } catch (e) {
                console.log(e);
            }
        }
        // scopes object
        outputJson.scopes_source = {
            items: [],
            env: '',
            type: ''
        };
        outputJson.scopes_baseline = {
            items: [],
            env: '',
            type: ''
        };
        outputJson.scopes_target = {
            items: [],
            env: '',
            type: ''
        };
        _.each(outputJson.scopes, (scope) => {
            const source = { schema: '', server: '' }, target = { schema: '', server: '' };
            outputJson.scopes_source.env = scope.SourceSchema.envName
            outputJson.scopes_source.type = inputJson.sourceCompareType;
            source.schema = scope.SourceSchema.name;
            source.server = scope.SourceSchema.hostName || 'N/A';
            outputJson.scopes_source.items.push(source);
            outputJson.scopes_target.type = inputJson.targetCompareType;
            outputJson.scopes_target.env = scope.TargetSchema.envName || 'N/A';
            target.schema = scope.TargetSchema.name;
            target.server = scope.TargetSchema.hostName || 'N/A';
            outputJson.scopes_target.items.push(target);
        });
        outputJson.has_baseline = (_.size(outputJson.scopes_baseline) == 0) ? false : true;
        outputJson.numberOfSets = _.size(outputJson.scopes); //(_.size(outputJson.scopes_baseline) == 0) ? 2 : 3;
        //changes list object
        outputJson.errors = [];
        _.each(outputJson.errorsList, (err) => {
            try {
                outputJson.errors.push({ errorDesc: err });
            }
            catch (e) {
                console.log(e);
            }
        });
        outputJson.changes = [];
        outputJson.contentChanges = [];
        _.each(outputJson.comparedObjects.ChangedObjects, (item) => { 
            outputJson.changes.push(this.populateChanges(item,outputJson,inputJson,envId));
            outputJson.contentChanges.push(this.populateChanges(item,outputJson,inputJson,envId));
         });
        
        //_.each(outputJson.comparedContent.ChangedObjects, (item) => outputJson.contentChanges.push(this.populateChanges(item,outputJson,inputJson,envId)));
        return outputJson;
    }

    private populateChanges(item, outputJson, inputJson, envId):any {
        try {
            let schema = null;
            schema = this.getSchema(item.schemaId, outputJson);
            const object = {
                is_build: (outputJson.operationType.toLowerCase().indexOf("build") != -1) || (outputJson.operationType.toLowerCase().indexOf("latest") != -1) || (outputJson.operationType.toLowerCase().indexOf("specific") != -1),
                env_name: schema.SourceSchema.envName,
                source_schema: schema.SourceSchema.name,
                target_schema: schema.TargetSchema.name,
                status: this.ChangeTypeToType(item.changeTypeId, inputJson),
                IsDrift: (inputJson.mainOperation == 'ENV_DRIFT_DETECTION'),
                envId: envId,
                id: item.schemaId,
                object_name: item.name,
                object_type: item.type,
                raw: item,
            }
            return object;
        } catch (e) {
            console.log(e);
        }
    }

    private convertUTCtoLocal(date):string {
        if (!date)
            return;
        //console.log("server",date);
        var stillUtc = moment.utc(date).toDate();
        var local = moment(stillUtc).local().toDate();//format('DD/MM/YYYY HH:mm:ss ');
        //console.log("UTC",local);
        return local.toLocaleString();
    }

    private getSchema(entityId, outputJson):string {
        const sourceEntity = _.find(outputJson.scopes, (scope) => scope.SourceSchema.id == entityId);
        return sourceEntity || _.find(outputJson.scopes, (scope) => scope.TargetSchema.id == entityId);;
    }
    private ChangeTypeToType(ChangeTypeId, inputJson) {
        let addTypeText:string = "Added";
        let updateTypeText:string = "Changed";
        let dropTypeText:string = "Dropped";
        if (inputJson.mainOperation == 'ENV_DRIFT_DETECTION' && ChangeTypeId == 0) {
            return dropTypeText;
        }
        switch (ChangeTypeId) {
            case 0:
                return addTypeText;
            case 1:
                return dropTypeText;
            case 2:
                return updateTypeText;
        }
    }



}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/services/trans-impact-server-client.ts